import { DataType } from '@mode-switch/express';
import { Encoding } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';

export type FieldFormatModalOpenAttributes = {
  title: string;
  colType: DataType.Name;
  format?: ChartTypes.TextFormat;
  defaultFormatType?: boolean;
  encoding?: Encoding;
  applyCustomFormat: (arg: { textFormat: ChartTypes.TextFormat }) => void;
};

export abstract class FieldFormatModalService {
  abstract open(attributes: FieldFormatModalOpenAttributes): void;
}
